export default function download_url(text: string, type: 'text/plain' | 'text/csv'): string {
    const url_generator = window.URL || window.webkitURL;
    const blob = new Blob([text], { type: type });
    const url = url_generator.createObjectURL(blob);
    return url;
}

